export const MAX_BREWING_TEMP = 100;
export const MAX_FERMENTING_TEMP = 40;
export const MAX_SERVING_TEMP = 20;
export const MAX_CLEANING_TEMP = 100;
